import { useAxiosCreate } from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header'


const api = useAxiosCreate('api')

export async function getTradingRates(params = {}) {
  const response = await api.get('memory/trading-rates', {
    params,
    headers: authHeader(),
  })
  return response.data
}

export async function createTradingRate(payload) {
  const response = await api.post('memory/trading-rates', payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function updateTradingRate(id, payload) {
  const response = await api.put(`memory/trading-rates/${id}`, payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function deleteTradingRate(id) {
  const response = await api.delete(`memory/trading-rates/${id}`, {
    headers: authHeader(),
  })
  return response.data
}

export async function exportTradingRates(params = {}) {
  return api.get('memory/trading-rates/export', {
    params,
    headers: authHeader(),
    responseType: 'blob',
    validateStatus: () => true,
  })
}

export async function importTradingRates(file) {
  const formData = new FormData()
  formData.append('file', file)
  const response = await api.post('memory/trading-rates/import', formData, {
    headers: authHeader(),
  })
  return response.data
}
